module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Tie-e63f6fd4469cd3c3f269c4c6f4e664ad.svg";